import DepositPaymentOrderSettings from "@/models/Products/ProductSettings/DefaultSettings/PaymentOrders/DepositPaymentOrderSettings";

export default class AccountDepositPaymentOrderSettings extends DepositPaymentOrderSettings {
    overridden: boolean = false;
}